import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconLabel$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLabel extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '12ab6b4c34e92c04417a482cf895c42239197ebe', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '74d8d815dee1a49151230ce266e147447e1a5444', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'afdec1ea35e472e258a4bef85a90fc7fdcf4f629', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.21 2a.47.47 0 0 0-.35.15l-9.5 9.5a.48.48 0 0 0 0 .7l7.27 7.28a.51.51 0 0 0 .71 0l9.52-9.48A.53.53 0 0 0 20 9.8V2.51a.5.5 0 0 0-.5-.5zm6.3 1.51v5.88L10 17.87 4.13 12l8.5-8.5h5.88zm-3.025 4.652a1.25 1.25 0 1 0-.97-2.304 1.25 1.25 0 0 0 .97 2.304", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-label", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-label"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-label":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLabel$1);
            }
            break;
    } });
}

const CosmosIconLabel = CosmosIconLabel$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLabel, defineCustomElement };
